// Shared by calendarDataReducer (the header's single calendarAction fallback
// pointer) and HistorySideBarContent (grouping a burst of history rows for
// display) - both need the same "close enough in time to be one gesture"
// threshold. Comparable to this codebase's existing field-edit debounce
// windows (e.g. the 4s per-table debounce), which is far more than a
// same-gesture burst needs but well under how long it'd take an unrelated,
// separate edit on the same day to land.
const CALENDAR_ACTION_MERGE_WINDOW_MS = 3000;

export default CALENDAR_ACTION_MERGE_WINDOW_MS;
